import Image from "next/image";
import { PropTypes } from "prop-types";

export const WorkInProgress = ({ enabled, children, notice }) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <div className="demyst-wip">
      <Image src="/construction.svg" width="100%" height="250" className="image" />
      <h1 className="title">Service Temporarily Unavailable</h1>
      <span>{notice}</span>
      <span>We're working to resolve this issue as quickly as possible.</span>
      <span>Please bear with us.</span>
    </div>
  );
};

WorkInProgress.protoTypes = {
  disabled: PropTypes.boolean,
  children: PropTypes.node,
  notice: PropTypes.string,
};
